module.exports = __webpack_public_path__ + "img/add.d9778e15.svg";